import React, { useState } from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import {
	Card,
	CardBody,
	CardHeader,
	Col,
	Container,
	Row,
	Form,
	FormFeedback,
	Label,
	Input,
	Button,
	Spinner,
} from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { Grid, Stack } from '@mantine/core';
import { Field } from '../Field';
import { addNewScreen, updateScreen } from '../../../../slices/thunks';
import { AddFieldButton } from './AddFieldButton';

const AddEditScreen = ({ dataScreen, isEdit }) => {
	const dispatch = useDispatch();

	const selectorScreen = createSelector(
		state => state.Screen,
		screen => ({
			isAdding: screen.isAdding,
			isAdded: screen.isAdded,
			isUpdating: screen.isUpdating,
			isUpdated: screen.isUpdated,
			isLoadingList: screen.isLoadingList,
			requireCloseModal: screen.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorScreen);

	// validation
	const validation = useFormik({
		initialValues: {
			name: (dataScreen && dataScreen.name) || '',
			description: (dataScreen && dataScreen.description) || '',
			fields: (dataScreen && dataScreen.fields) || [[]],
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			description: Yup.string().required('Campo requerido'),
			fields: Yup.array().of(
				Yup.array().of(
					Yup.object().shape({
						field_id: Yup.string().required('Campo requerido'),
						// optional: Yup.boolean().required('Campo requerido'),
						// size: Yup.number().required('Campo requerido'),
					})
				)
			),
		}),
		onSubmit: values => {
			const screen = {
				name: values.name,
				description: values.description,
				fields: values.fields,
			};

			console.log(values);

			if (isEdit) {
				screen._id = dataScreen._id;
				dispatch(updateScreen(screen));
			} else {
				dispatch(addNewScreen(screen));
			}
		},
	});

	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{
			to: '/screen/list',
			label: 'Pantallas',
		},
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Crear Pantalla' links={breadcrumbLinks} />
					<Row>
						<Col lg={12}>
							<Card>
								{/* <CardHeader className='border-0 pb-0'>
									<div className='d-flex align-items-end justify-content-end'>
										<div className='flex-shrink-0'>
											<div className='d-flex flex-wrap gap-2'>
												<button
													className='btn btn-label btn-primary'
													onClick={() => {
														navigate('/screens/add');
													}}
												>
													<i className={`${Icons.plus} label-icon`}></i>{' '}
													Crear Pantalla
												</button>
											</div>
										</div>
									</div>
								</CardHeader> */}
								<CardBody>
									<Form
										className='tablelist-form'
										onSubmit={e => {
											e.preventDefault();

											validation.handleSubmit();
											return false;
										}}
									>
										<Row className='g-3'>
											<Col lg={8}>
												<Label for='name' className='form-label'>
													Nombre
												</Label>
												<Input
													name='name'
													id='name'
													className='form-control'
													placeholder='Ingrese un nombre'
													type='text'
													validate={{ required: { value: true } }}
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={validation.values.name || ''}
													invalid={
														validation.touched.name &&
														validation.errors.name
															? true
															: false
													}
												/>
												{validation.touched.name &&
												validation.errors.name ? (
													<FormFeedback type='invalid'>
														{validation.errors.name}
													</FormFeedback>
												) : null}
											</Col>
											<Col lg={4}>
												<Label
													for='description'
													className='form-label'
												>
													Descripción
												</Label>
												<Input
													name='description'
													id='description'
													className='form-control'
													placeholder='Ingrese una descripción'
													type='text'
													validate={{ required: { value: true } }}
													onChange={validation.handleChange}
													onBlur={validation.handleBlur}
													value={
														validation.values.description || ''
													}
													invalid={
														validation.touched.description &&
														validation.errors.description
															? true
															: false
													}
												/>
												{validation.touched.description &&
												validation.errors.description ? (
													<FormFeedback type='invalid'>
														{validation.errors.description}
													</FormFeedback>
												) : null}
											</Col>
										</Row>
										<div className='modal-footer'>
											<div className='hstack gap-2 justify-content-end'>
												<Button
													type='button'
													onClick={() => {
														handleToggleModal();
													}}
													className='btn-danger btn-label'
												>
													<i className='icon-x label-icon'></i>
													Cancelar
												</Button>
												<button
													type='submit'
													className='btn btn-label btn-primary'
													id='add-btn'
													disabled={isAdding || isUpdating}
												>
													{isAdding || isUpdating ? (
														<i className='label-icon'>
															<Spinner size='sm' />
														</i>
													) : (
														<i className='ri-save-3-line label-icon'></i>
													)}
													{isEdit ? 'Editar' : 'Crear'} Pantalla
												</button>
											</div>
										</div>
									</Form>
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<Card>
								<CardBody>
									<Stack>
										<AddFieldButton
											dataField={{}}
											isEdit={false}
											resultHandler={result => {
												validation.values.fields[0].push({
													field_id: result._id,
													optional: false,
													size: 4,
												});
											}}
										/>
										{validation.values.fields.map((row, index) => (
											<Grid key={index}>
												{row.map((field, index) => (
													<Field
														key={index}
														form={{ getInputProps: () => {} }}
														field={field}
													/>
												))}
											</Grid>
										))}
									</Stack>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default AddEditScreen;
